<template>
  <div class="step">
    <div class="step__headline">
      <h3 class="step__title">Выберите параметры</h3>
      <div class="step__pagecounter">Шаг 1 из 3</div>
    </div>
    <TagInput name="countries" :values="countries" allvalue="Весь мир" v-model="form.travel.countries" @update:modelValue="$nextTick(()=>$store.dispatch('updateAddonsPrice'))"/>
    <div class="step__split" style="padding-top: 1px">
      <CheckBox name="yearpolis-enabled" v-model="form.travel.yearpolis.enabled" :tooltip="yearpolis_tooltip" @update:modelValue="$nextTick(()=>$store.dispatch('updateAddonsPrice'))">Полис на год</CheckBox>
      <CheckBox name="already-travel" v-model="form.travel.already" :tooltip="already_travel_tooltip" @update:modelValue="$store.dispatch('updateAddonsPrice')">Уже путешествую</CheckBox>
    </div>
    <div style="margin-top: -3px">
      <DateInput ref="dates" name="dates" text="Выберите даты поездки" :range="true" v-model="form.travel.dates" v-if="!form.travel.yearpolis.enabled" :filled="datesFilled" placeholder="01.06.2023 — 21.06.2023" @correctlyFilled="$nextTick(()=>$store.dispatch('updateAddonsPrice'))" />
      <div v-else class="step__split">
        <DateInput ref="polisdate" class="calc-desk-mb0" name="yearpolis-start" text="Дата начала" v-model="form.travel.yearpolis.start" :filled="dateFilled" placeholder="01.06.2023" @correctlyFilled="$nextTick(()=>$store.dispatch('updateAddonsPrice'))"/>
        <SelInput text="Количество дней" name="yearpolis-days" :options="['15','30','45','60','75']" v-model="form.travel.yearpolis.days" @correctlyFilled="$store.dispatch('updateAddonsPrice')" />
      </div>
    </div>
    <div class="step__split" style="padding-top: 2px">
      <SelInput text="Валюта страхования" name="currency" :options="['Евро', 'Доллар', 'Рубль']" v-model="form.travel.currency" @update:modelValue="$store.dispatch('updateAddonsPrice')" />
      <SelInput text="Страховая сумма" name="inssum" :options="['5 000', '15 000', '30 000', '35 000', '40 000', '50 000', '100 000']" v-model="form.travel.insurancesum" @update:modelValue="$store.dispatch('updateAddonsPrice')"/>
<!--      <SelInput text="Страховая сумма" name="inssum" :options="[form.travel.currency == 'Евро' ? '35 000' : '40 000', '50 000', '100 000']" v-model="form.travel.insurancesum" />-->
    </div>
    <div style="padding-top: 2px" class="mb0">
      <SelInput v-model="form.travel.resttype" name="resttype" text="Тип отдыха" :options="['Спокойный отдых', 'Активный отдых', 'Зимний активный отдых', 'Спорт', 'Экстремальный отдых', 'Профессиональный риск']" class="mb0" @update:modelValue="$store.dispatch('updateAddonsPrice')" />
    </div>
    <a :href="detailslink" class="newred step__afterlink mb0">Подробнее</a>
    <div class="step__divideline step__divideline_big calc-disappearing"></div>
    <div class="step__buttonwrap">
      <p class="step__buttonwrap-text">Нажимая кнопку «Далее» я&nbsp;принимаю условия ...</p>
      <Btn class="step__button" :disabled="!$store.state.stepsfilled[0]" @click="toNextStep">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Btn from './Btn.vue'
import CheckBox from './inputs/CheckBox.vue';
import DateInput from './inputs/DateInput.vue';
import SelInput from './inputs/SelInput.vue';
import TagInput from './inputs/TagInput.vue';

export default {
  components: { CheckBox, Btn, TagInput, DateInput, SelInput },
  data: () => ({
    actions: {},
    countries: ['Острова Карибского бассейна', 'Доминиканская Республика', 'Гаити', 'Ямайка', 'Пуэрто-Рико', 'Тринидад и Тобаго', 'Гваделупа', 'Мартиника', 'Доминика', 'Сент-Люсия', 'Кюрасао', 'Антигуа и Барбуда', 'Барбадос', 'Сент-Винсент и Гренадины', 'Виргинские острова', 'Аруба', 'Ангилья', 'Непал', 'Весь Мир', 'Таджикистан', 'Киргизия', 'Юго-Восточная Азия', 'Вьетнам', 'Таиланд', 'Филиппины', 'Мьянма', 'Лаос', 'Камбоджа', 'Сингапур', 'Индонезия', 'Малайзия', 'Бруней', 'Восточный Тимор', 'Индия', 'США', 'Канада', 'Новая Зеландия', 'Австралия', 'Япония', 'Мексика', 'Острова Океании', 'Вануату', 'Папуа - Новая Гвинея', 'Соломоновы острова', 'Фиджи', 'Карибати', 'Маршалловы Острова', 'Науру', 'Палау', 'Федеративные Штаты Микронезии', 'Кирибати', 'Самоа', 'Тонга', 'Тувалу', 'Багамские острова', 'Бермудские острова', 'Колумбия', 'Маврикий', 'Израиль', 'Австрия ', 'Албания ', 'Андорра ', 'Бельгия', 'Болгария ', 'Босния и Герцеговина ', 'Ватикан ', 'Великобритания ', 'Венгрия ', 'Германия ', 'Греция ', 'Дания', 'Ирландия ', 'Исландия ', 'Испания ', 'Италия ', 'Латвия ', 'Литва', 'Лихтенштейн ', 'Люксембург ', 'Македония ', 'Мальта ', 'Монако ', 'Нидерланды', 'Норвегия ', 'Польша ', 'Португалия ', 'Румыния ', 'Сан-Марино ', 'Сербия ', 'Словакия', 'Словения ', 'Финляндия ', 'Франция ', 'Хорватия', 'Черногория ', 'Чехия ', 'Швейцария ', 'Швеция ', 'Шенген', 'Эстония', 'Кипр', 'Турция', 'Россия', 'Украина', 'Белоруссия', 'Молдавия', 'Грузия', 'Армения', 'Казахстан', 'Туркмения', 'Узбекистан', 'Азербайджан', 'Абхазия', 'Алжир', 'Ангола', 'Аргентина', 'Афганистан', 'Бангладеш', 'Бахрейн', 'Белиз', 'Бенин', 'Боливия', 'Ботсвана', 'Бразилия', 'Буркина-Фасо', 'Бурунди', 'Бутан', 'Венесуэла', 'Габон', 'Гайана', 'Гамбия', 'Гана', 'Гватемала', 'Гвиана', 'Гондурас', 'Гонконг', 'Гренада', 'Гренландия', 'Демократическая Республика Конго', 'Джибути', 'Египет', 'Замбия', 'Зимбабве', 'Йемен', 'Иордания', 'Ирак', 'Иран', 'Кабо-Верде', 'Камерун', 'Катар', 'Кения', 'Китай', 'КНДР', 'Коморы', 'Коста-Рика', 'Кот-д’Ивуар', 'Куба', 'Кувейт', 'Лесото', 'Либерия', 'Ливан', 'Мавритания', 'Мадагаскар', 'Макао', 'Малави', 'Мали', 'Мальдивы', 'Марокко', 'Мозамбик', 'Монголия', 'Намибия', 'Нигер', 'Нигерия', 'Никарагуа', 'ОАЭ', 'Оман', 'Пакистан', 'Панама', 'Парагвай', 'Перу', 'Руанда', 'Сальвадор', 'Саудовская Аравия', 'Сейшельские Острова', 'Сенегал', 'Сирия', 'Сомали', 'Судан', 'Суринам', 'Тайвань', 'Танзания', 'Того', 'Тунис', 'Уганда', 'Уругвай', 'Фарерские острова', 'ЦАР', 'Чад', 'Чили', 'Шри-Ланка', 'Эквадор', 'Эритрея', 'Эфиопия', 'ЮАР', 'Южная Корея', 'Южная Осетия'],
    yearpolis_tooltip: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum dolore voluptate dolor nostrum ex qui et dignissimos veritatis eum ducimus!',
    already_travel_tooltip: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum dolore voluptate dolor nostrum ex qui et dignissimos veritatis eum ducimus!',
  }),
  computed: {
    ...mapState(['form', 'detailslink']),
    ok(){
      let f = this.form
      if (!this.cdateok) return false
      if (!f.travel.currency) return false
      if (!f.travel.insurancesum) return false
      if (!f.travel.resttype) return false
      return true
    },
    cdateok(){
      let f = this.form
      if (!f.travel.countries || !f.travel.countries.length) return false
      if (f.travel.yearpolis.enabled && (!f.travel.yearpolis.start || !f.travel.yearpolis.days || this.$refs.polisdate?.$data?.error || !this.dateFilled(f.travel.yearpolis.start))) return false
      if (!f.travel.yearpolis.enabled && (!f.travel.dates || this.$refs.dates?.$data?.error || !this.datesFilled(f.travel.dates))) return false
      return true
    }
  },
  methods: {
    datesFilled(v){
      return v.match(/\d\d\.\d\d\.\d\d\d\d — \d\d\.\d\d\.\d\d\d\d/)
    },
    dateFilled(v){
      return v.match(/\d\d\.\d\d\.\d\d\d\d/)
    },
    toNextStep() {
      if (!this.actions.step2) {
        this.actions.step2 = true
        this.$store.dispatch('callAction', 'step2')
      }
      this.$store.dispatch('nextStep')
    }
  },
  watch: {
    ok(v,old){
      if (v!=old)
        this.$store.commit('setStepFill',[0, v])
    },
    cdateok(v,old){
      if (v!=old)  {
        this.$store.commit('setcountryDateFilled', v)
        /*
        if (v) 
          this.$store.dispatch('updateAddonsPrice')*/
      }
    }
  }
}
</script>

<style lang="sass">
.step
  padding-bottom: 60px
  font-size: 14px
  line-height: 1.12
  &__divideline
    background: colors.$moar_silver_for_the_god_of_silver
    margin: 24px 0
    height: 1px
    &_big
      margin: 40px 0
    &_shrinking
      @include from(820px)
        margin: 10px 0 12px
  &__afterlink
    display: inline-block
    font-size: 14px
    line-height: 1.12
    margin-top: 15px
  &__split
    display: flex
    justify-content: space-between
    >*
      width: calc(50% - 16px)
      @inlcude since(440.02px)
        margin-bottom: 0 !important
    @include from(440px)
      display: block
      margin-bottom: 0 !important
      >*
        width: 100%
  &__buttonwrap
    display: flex
    justify-content: space-between
    align-items: center
    &-text
      letter-spacing: globalvars.$onespacing
      font-size: 12px
      line-height: 1.14
    @include from(820px)
      margin-top: 40px
      display: block
      &-text
        text-align: center
        margin-bottom: 10px
      .step__button
        margin-right: auto
  &__button
    width: 327px
    max-width: 100%
    flex-shrink: 0
    margin-left: auto
  >*:not(:last-child)
    margin-bottom: 40px
    @include from(820px)
      margin-bottom: 24px
    &.mb0
      margin-bottom: 0
  &__headline
    display: flex
    justify-content: space-between
    @include from(440px)
      flex-wrap: wrap-reverse
      gap: 10px
  & h3.step__title
    font-weight: 500
    font-size: 24px
    line-height: 1.16
    color: colors.$gray3
    letter-spacing: globalvars.$onespacing
  & h4.step__title
    font-weight: 500
    font-size: 20px
    line-height: 1.18
    @include from(820px)
      margin-bottom: 10px
      &:not(:first-child)
        margin-top: 30px
      
  &__pagecounter
    font-weight: 500

</style>